import { z } from "zod";

export const withdrawalFormSchema = z.object({
  amount: z.coerce.number().positive("Amount must be greater than 0"),
  withdrawal_date: z.string().min(1, "Withdrawal date is required").refine(
    (val) => !isNaN(Date.parse(val)),
    "Invalid date"
  ),
  note: z.string().optional(),
  // Create-only field
  target_account_id: z.string().optional(),
});

export type WithdrawalFormValues = z.infer<typeof withdrawalFormSchema>;

/**
 * Creates a withdrawal schema with a balance guard and enforces target_account_id on create.
 */
export function createWithdrawalSchema(currentDepositBalance: number, isEdit = false) {
  return withdrawalFormSchema.superRefine((data, ctx) => {
    if (data.amount > currentDepositBalance) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["amount"],
        message: `Withdrawal amount cannot exceed current deposit balance of ${currentDepositBalance}`,
      });
    }
    if (!isEdit && !data.target_account_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["target_account_id"],
        message: "Target account is required",
      });
    }
  });
}
